var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 96 96",
    style: {
      enableBackground: "new 0 0 96 96"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M37.456,56.357h-14c-1.104,0-2,0.896-2,2v14c0,1.104,0.896,2,2,2h14c1.104,0,2-0.896,2-2v-14 C39.456,57.253,38.561,56.357,37.456,56.357z M35.456,70.357h-10v-10h10V70.357z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.456,42.098h14c1.104,0,2-0.896,2-2v-14c0-1.104-0.896-2-2-2h-14c-1.104,0-2,0.896-2,2v14 C21.456,41.203,22.352,42.098,23.456,42.098z M25.456,28.098h10v10h-10V28.098z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.903,42.098h14c1.104,0,2-0.896,2-2v-14c0-1.104-0.896-2-2-2h-14c-1.104,0-2,0.896-2,2v14 C53.903,41.203,54.799,42.098,55.903,42.098z M57.903,28.098h10v10h-10V28.098z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.903,67.357c1.104,0,2-0.896,2-2V49.321c0-1.104-0.896-2-2-2H48c-1.104,0-2,0.896-2,2s0.896,2,2,2h5.903v14.036 C53.903,66.462,54.799,67.357,55.903,67.357z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.68,42.098c1.104,0,2-0.896,2-2v-7c0-1.104-0.896-2-2-2s-2,0.896-2,2v7C44.68,41.203,45.575,42.098,46.68,42.098z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.364,49.321v8.018c0,1.104,0.896,2,2,2s2-0.896,2-2v-8.018c0-1.104-0.896-2-2-2S63.364,48.217,63.364,49.321z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.806,63.357c-1.104,0-2,0.896-2,2v5.188H55.903c-1.104,0-2,0.896-2,2s0.896,2,2,2h14.902c1.104,0,2-0.896,2-2v-7.188 C72.806,64.253,71.91,63.357,70.806,63.357z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.68,55.339c-1.104,0-2,0.896-2,2v15.019c0,1.104,0.896,2,2,2s2-0.896,2-2V57.339 C48.68,56.234,47.784,55.339,46.68,55.339z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.456,51.321h7c1.104,0,2-0.896,2-2s-0.896-2-2-2h-7c-1.104,0-2,0.896-2,2S22.352,51.321,23.456,51.321z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.461,45.571c-1.104,0-2,0.896-2,2v3.5c0,1.104,0.896,2,2,2s2-0.896,2-2v-3.5C40.461,46.467,39.565,45.571,38.461,45.571 z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQr);
export default __webpack_public_path__ + "static/media/qr.a4adcb6488ce480380c3fb0716b5f0b3.svg";
export { ForwardRef as ReactComponent };